import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

const AnswerButton = ({ answer, question, onAnswerPress, values }) => {
  const isSelected = values[question.customId]
    ? values[question.customId].answers.find(({ customId }) => customId === answer.customId) !==
      undefined
    : false

  return (
    <div
      className={`answer-button ${isSelected && 'selected'}`}
      key={answer.id}
      onClick={() => onAnswerPress(question, answer)}
      data-tip
      data-for={`answer-button-tooltip-${answer.customId}`}
    >
      <span>{answer.title}</span>
      <ReactTooltip
        className="tooltip"
        id={`answer-button-tooltip-${answer.customId}`}
        multiline
        effect="solid"
      >
        {answer.title}
      </ReactTooltip>
    </div>
  )
}

AnswerButton.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object,
  onAnswerPress: PropTypes.func,
  values: PropTypes.object,
}

export default AnswerButton
